import Api from './ApiRequest';

export default  {
    getAll: (params) => Api.get('/training/assignments', params),
    getById: (id) => Api.get('/training/assignment/' + id, null),
    save: (entity) => Api.post('/training/assignment', entity),
    update: (id, entity) => Api.put('/training/assignment/' + id, entity),
    delete: (id) => Api.delete('/training/assignment/' + id),
    search: (searchText, params) => Api.get('/training/assignments/search', {q: searchText, ...params}),
    getStats: () => Api.get('/training/assignments/stats', null),
    getCount: () => Api.get('/training/assignments/count'),
    run: (id) => Api.put('/training/assignment/' + id + '/run'),
};